export default __webpack_public_path__ + "static/media/install_profile.05817857.png";